var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 315.6 331.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.47,235.1l48.13,24.56c-24.56,38.48-64,72.2-128.91,72.2-77.94,0-141.4-45.72-161.63-116.42H0V183.21H19.24c-.5-5.75-1-11.57-1-17.32,0-6.24.5-12.49,1-18.24H0V115.42H25.48C45.71,45.22,109.18,0,186.62,0c64.95,0,104.85,33.65,128.91,72.19L267.4,96.75C252,70.28,221.19,50.12,186.62,50.12c-46.21,0-83.69,25.48-100.52,65.44H216v32.23H77c-.5,5.75-1,12-1,18.24,0,5.75.49,11.57,1,17.32H216.08v32.23H85.68C102.5,256,140.05,282,186.69,282,221.33,281.74,252.07,262.08,267.47,235.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuro);
export default __webpack_public_path__ + "static/media/euro.5679472d4db294e76b56d3b369801fb3.svg";
export { ForwardRef as ReactComponent };